<template>
  <div>
    <div class="fixed_page"  id="blurry">
      <div class="get-started popup_bg">
        <div class="store-main">
          <div class="fixed_page">
            <div class="store_box">
              <img :src="storeMainImgSrc">
              <h1>{{ getTranslations.home_store_title }}</h1>
              <p v-if="!isDiscountEnabled">{{ getTranslations.home_store_unlock_more }}<br> {{ getTranslations.home_store_play_more }}</p>
              <p v-else>{{ getTranslations.home_store_active_bonus }}<br> {{ getTranslations.home_store_active_bonus_get }} {{ storedBundles[0].multiplier }} {{ getTranslations.home_store_active_bonus_amount }}</p>

              <div class="store_countdown" v-if="isDiscountEnabled">
                <p v-if="counter"></p>
              </div>

              <div :class="['store_container', { no_bonus: isDiscountEnabled }]">

                <div v-for="(storeItem, index) in orderedStoreItems" :key="index">
                <div class="store_row">
                  <div class="store_col">
                    <p v-if="isDiscountEnabled">{{ storeItem.noOfGames ? storeItem.noOfGames / storeItem.multiplier + ' ' + getTranslations.home_store_games : '' }}</p>
                    <h6>{{ storeItem.noOfGames ? storeItem.noOfGames + ' ' + getTranslations.home_store_games : ' ' }}
                      {{storeItem.noOfGames && storeItem.points?getTranslations.home_store_and :''}}
                    {{ storeItem.points ? storeItem.points + ' ' + getTranslations.home_store_points : " "}}</h6>
                  </div>
                  <div class="store_vertical_border"></div>
                  <button type="" @click.prevent="getIt(storeItem.bundleId, storeItem.noOfGames, storeItem.price, storeItem.currencyCode, storeItem.points)">
                    {{ storeItem.price}} {{ storeItem.currencyCode }}
                  </button>
                </div>

                <div class="store_horizontal_border"></div>
                </div>

                <div class="store_row" v-if="inviteConfig.inviteEnable && fbInviteEnable()">
                  <div class="store_col invite">
                    <p>1 {{ getTranslations.home_store_game }}<br> {{ getTranslations.home_store_suc_friend }}</p>
                  </div>
                  <div class="store_vertical_border"></div>
                  <button type="" @click.prevent="shareFriendsInvitation()">{{ getTranslations.home_store_invite }}</button>
                </div>
                <div class="store_horizontal_border"></div>
              </div>
              <div class="vat_box" v-if="vatBanner">
                <p>{{ getTranslations.home_store_vat }}<br> {{ getTranslations.home_store_vat_will_be }}</p>
              </div>
              <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.home_store_this_fb }}</span>
            </div>
            <div class="circle_background popup_circle_bg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- dynamically change modals -->
    <component :is="modalForStore" @bundlePurchase="onBundlePurchase" @close="storeModalForStore(null)"></component>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */

import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Vue from 'vue';
import $ from 'jquery';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import SkinMixin from '@/common/mixins/skin';
import modals from '@/common/modals';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ConfirmPurchase from './modals/store/ConfirmPurchase';
import ConfirmPurchaseForPin from './modals/store/ConfirmPurchaseForPin';
import ConfirmPurchaseForPinError from './modals/store/ConfirmPurchaseForPinError';
import ConfirmPurchaseViaSms from './modals/store/ConfirmPurchaseViaSms';
import InviteFriend from './modals/users/InviteFriend';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'store',
  components: { InviteFriend },
  mixins: [FacebookMixin, SkinMixin],
  data() {
    return {
      fb_error: false,
      redirectUrl: '',
      timer: 0,
      counter: '',
      dateEnd: null,
      isDiscountEnabled: false,
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  mounted() {
    // init google analytics (from the imported mixin)
    this.storedBundlesCall().then(() => {
      if (!!this.storedBundles && this.storedBundles.length > 0 && !!this.storedBundles[0].multiplier && !!this.storedBundles[0].endBonusDate) this.calculateBonusPhaseTimer();
    });
  },
  methods: {
    ...mapActions('profile', [
      'requestPin',
      'storedBundlesCall',
      'getUserLoginDetails',
    ]),
    ...mapMutations('profile', [
      'setBundleId',
      'setBundleData',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    calculateBonusPhaseTimer() {
      this.dateEnd = moment(this.storedBundles[0].endBonusDate).format('hh:mm:ss');
      const interval = 1000; // every 1 second
      let duration;
      // get time element
      // calculate difference between two times
      const eventTime = moment(this.storedBundles[0].endBonusDate);
      // loop to countdown every 1 second
      this.timer = setInterval(() => {
        // based on time set in user's computer time / OS
        const currentTime = moment(new Date());
        // get duration between two times
        duration = moment.duration(eventTime.diff(currentTime));
        // get updated duration
        duration = moment.duration(duration - interval, 'milliseconds');

        // if duration is >= 0
        if (currentTime.isAfter(eventTime)) {
          clearInterval(this.timer);
          // hide the countdown element
          this.counter = '';
          this.isDiscountEnabled = false;
        } else {
          // otherwise, show the updated countdown
          this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
          $('.store_countdown p').html(this.counter);
          this.isDiscountEnabled = true;
        }
      }, interval);
    },
    fbInviteEnable() {
      // eslint-disable-next-line
      //this.getIntegrationConfig.config.inviteFBenable not used anymore
      return this.facebookFunctionality;
    },
    onBundlePurchase() {
      this.getUserLoginDetails();
    },
    shareFriendsInvitation() {
      this.storeModalForStore(InviteFriend);
      this.showModal();
    },
    showError() {
      this.fb_error = true;
    },
    showModal() {
      modals.showHideModalInStore(this);
    },
    getIt(bundleId, numberOfCoins, price1, currencyCode1, points) {
      this.getUserLoginDetails().then(() => {
        if (this.purchaseBundleFromUnsubUser) {
          this.getBundle(bundleId, numberOfCoins, price1, currencyCode1, points);
        } else {
          // eslint-disable-next-line
          if (!this.userDetails.subscribed) {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForStore(ResubscribeGameSms);
              } else {
                this.storeModalForStore(ResubscribeGame);
              }
            } else {
              this.storeModalForStore(ResubscribeGame);
            }
            this.showModal();
          } else {
            this.getBundle(bundleId, numberOfCoins, price1, currencyCode1, points);
          }
        }
      });
    },
    getBundle(bundleId, numberOfCoins, price1, currencyCode1, point1) {
      this.setBundleId(bundleId);
      const bundleData = {
        numberOfCoins,
        price: price1,
        currencyCode: currencyCode1,
        points: point1,
      };
      this.setBundleData({ bundleDataObject: bundleData });
      if (this.purchaseViaSMS) {
        if (this.smsAutomaticResponse) {
          const phoneNumber = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'home_store_sortcode');
          const message = this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'home_store_keyword');
          let smsLink;
          if (this.isAndroid()) {
            smsLink = `sms:${phoneNumber}?body=${message}`;
            window.location.href = smsLink;
          } else if (this.isiOS()) {
            smsLink = `sms:${phoneNumber}&body=${message}`;
            window.location.href = smsLink;
          } else {
            this.storeModalForStore(ConfirmPurchaseViaSms);
            this.showModal();
          }
        } else {
          this.storeModalForStore(ConfirmPurchaseViaSms);
          this.showModal();
        }
      } else {
        // eslint-disable-next-line
        if (this.pinForBundles) {
          const bundleInfo = {
            bundleId: this.bundleId,
          };
          this.requestPin({ value: bundleInfo }).then(() => {
            if (this.requestPinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseForPin);
              this.showModal();
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
              this.showModal();
            }
          });
        } else {
          this.storeModalForStore(ConfirmPurchase);
          this.showModal();
        }
      }
    },
    isAndroid() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android/i.test(userAgent);
    },
    isiOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    },
  },
  computed: {
    ...mapState('common', [
      'inviteConfig',
      'smsAutomaticResponse',
      'purchaseBundleFromUnsubUser',
      'facebookFunctionality',
      'subAndUnsubViaSMS',
      'multiOperatorInfo',
      'reoptinAndOptoutConfig',
      'pinForBundles',
      'purchaseViaSMS',
      'modalForStore',
      'userDetails',
      'vatBanner',
    ]),
    ...mapState('profile', [
      'storedBundles',
      'requestPinResponse',
      'bundleId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    storeMainImgSrc() {
      return this.$_skinImage({ fileName: 'store/Store-Main-XL.png', skins: [100] });
    },
    orderedStoreItems() {
      // sort items by date ascending
      return !this.storedBundles || this.storedBundles.slice(0).sort((a, b) => a.noOfGames - b.noOfGames);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/Store.vue